// One feedback section: its header, its state, and its content when it has any.
// Presentational. The container decides which state it is in.

import React from 'react';
import { taraStageStatusChip } from '../utils/taraFeedbackStatus';

export default function TaraFeedbackSection({
  title, phase, statusLabel, lockReason, progress, error,
  runLabel, onRun, onRetry, children,
}) {
  const status = phase === 'ready' ? taraStageStatusChip(statusLabel) : null;

  return (
    <section
      className={`tara-fb-section ${phase}`}
      aria-disabled={phase === 'locked' ? 'true' : undefined}
    >
      <div className="tara-fb-section-head">
        <h3 className="tara-fb-section-title">{title}</h3>
        {status ? <span className={`tara-fb-chip ${status.tone}`}>{status.chip}</span> : null}
      </div>

      {status && status.explainer
        ? <p className="tara-fb-explainer">{status.explainer}</p>
        : null}

      {phase === 'locked' ? <p className="tara-fb-locked">{lockReason}</p> : null}

      {phase === 'idle' ? (
        <button type="button" className="tara-ws-start-btn" onClick={onRun}>
          {runLabel}
        </button>
      ) : null}

      {phase === 'running' ? (
        <div className="tara-fb-progress">
          <p className="tara-fb-progress-text">{progress}</p>
          <span className="tara-fb-progress-bar" />
        </div>
      ) : null}

      {phase === 'error' && error ? (
        <div className="tara-fb-error">
          <p>{error.message}</p>
          {error.retryable ? (
            <button type="button" className="tara-ws-start-btn ghost" onClick={onRetry}>
              Try again
            </button>
          ) : null}
        </div>
      ) : null}

      {phase === 'ready' ? children : null}
    </section>
  );
}
